// extracted by mini-css-extract-plugin
module.exports = {"ContacttDiv":"Contact_ContacttDiv__1wKAl","ContactlFont":"Contact_ContactlFont__1nGAx","mapBd":"Contact_mapBd__2Dt3-"};